var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "md-layout",
    [
      _c("div", { staticClass: "md-headline" }, [_vm._v("Preview")]),
      _c(
        "md-layout",
        { attrs: { "md-flex": "100" } },
        [
          _c(
            "md-layout",
            { staticClass: "video-frame", attrs: { "md-flex": "80" } },
            [
              _c("div", {
                staticClass: "rhebus-video-player",
                attrs: {
                  id: _vm.contentDistributionId,
                  "data-distribution-id": _vm.distributionId,
                  "data-width": _vm.playerWidth,
                  "data-height": _vm.playerHeight
                }
              })
            ]
          )
        ],
        1
      ),
      _c("md-layout", { attrs: { "md-flex": "100" } }, [
        _c("span", { staticClass: "md-caption" }, [
          _vm._v(
            "Please note that feeds are cached for up to 1 minute, so changes may not immediately reflect in the player."
          )
        ])
      ]),
      _c(
        "md-layout",
        { attrs: { id: "code-examples", "md-flex": "100" } },
        [
          _c(
            "md-layout",
            { attrs: { "md-flex": "100" } },
            _vm._l(_vm.codeConfigActives, function(config) {
              return _c(
                "md-radio",
                {
                  key: config.key,
                  attrs: { "md-value": config.type },
                  model: {
                    value: _vm.codeSample,
                    callback: function($$v) {
                      _vm.codeSample = $$v
                    },
                    expression: "codeSample"
                  }
                },
                [
                  _vm._v(
                    _vm._s(
                      config.radioLabel ||
                        config.type.charAt(0).toUpperCase() +
                          config.type.slice(1)
                    )
                  )
                ]
              )
            }),
            1
          ),
          _c("transition-group", {
            attrs: {
              name: "fade",
              "enter-active-class": "animated fadeIn",
              "enter-leave-class": "animated fadeOut",
              mode: "out-in"
            }
          }),
          _vm._l(_vm.codeConfigs, function(config) {
            return [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.codeSample === config.type,
                      expression: "codeSample === config.type"
                    }
                  ],
                  key: config.key,
                  staticClass: "code-block"
                },
                [
                  config.blocks
                    ? [
                        _vm._l(config.blocks, function(block) {
                          return [
                            _c(
                              "div",
                              { staticClass: "link-wrapper" },
                              [
                                _c("span", { staticClass: "code-label" }, [
                                  _vm._v(_vm._s(block.label))
                                ]),
                                _c(
                                  "md-button",
                                  {
                                    directives: [
                                      {
                                        name: "clipboard",
                                        rawName: "v-clipboard",
                                        value: block.getCode(),
                                        expression: "block.getCode()"
                                      }
                                    ],
                                    staticClass:
                                      "copy md-icon-button md-primary",
                                    on: { success: _vm.copiedToClipBoard }
                                  },
                                  [
                                    _c("md-icon", {
                                      attrs: { "md-iconset": "fa fa-clone" }
                                    })
                                  ],
                                  1
                                ),
                                _c("pre", [
                                  _c("code", [_vm._v(_vm._s(block.getCode()))])
                                ])
                              ],
                              1
                            )
                          ]
                        })
                      ]
                    : [
                        _c(
                          "div",
                          { staticClass: "link-wrapper" },
                          [
                            _c("span", { staticClass: "code-label" }, [
                              _vm._v(_vm._s(config.label))
                            ]),
                            _c(
                              "md-button",
                              {
                                directives: [
                                  {
                                    name: "clipboard",
                                    rawName: "v-clipboard",
                                    value: config.getCode(),
                                    expression: "config.getCode()"
                                  }
                                ],
                                staticClass: "copy md-icon-button md-primary",
                                on: { success: _vm.copiedToClipBoard }
                              },
                              [
                                _c("md-icon", {
                                  attrs: { "md-iconset": "fa fa-clone" }
                                })
                              ],
                              1
                            ),
                            _c("pre", [
                              _c("code", [_vm._v(_vm._s(config.getCode()))])
                            ])
                          ],
                          1
                        )
                      ]
                ],
                2
              )
            ]
          })
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6c35708b", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c35708b","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug&optionsId=0!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/shared-components/video/VideoPreview.vue
// module id = 792
// module chunks = 0